export default "__VITE_PUBLIC_ASSET__6fbd44b9__"